import React, { FunctionComponent } from 'react';

import { getAddDriver } from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';
import { SingleYesNoStep } from 'scenes/common/components/Steps';
import analytics from 'scenes/motor/analytics';
import { YesNoAnswer } from 'scenes/common/types';
import { getApiData } from 'scenes/common/helpers/apiData';

const STATE_KEY = 'addDriver';
const QUESTION = 'Would you like to add an additional driver?';

export const AdditionalDriversQuestion: FunctionComponent<Pick<
  MotorFullPageProps,
  'funnelState' | 'referenceData' | 'onNext'
>> = ({ funnelState, referenceData, onNext }) => (
  <SingleYesNoStep
    question={QUESTION}
    stateKey={STATE_KEY}
    defaultStateValue={getAddDriver(funnelState)}
    onNext={(values) => {
      if (values.addDriver === YesNoAnswer.Yes) {
        analytics().addDriver(funnelState, getApiData(referenceData));
      }
      onNext(values);
    }}
  />
);

export default AdditionalDriversQuestion;
